import { useEffect, useState } from "react";
import { Box, Container, Grid, Stack, Typography } from "@mui/material";

import { Section } from "..";
import { Tab } from "../API/CodeBlocks";
// import CodeBlocks from "./CodeBlocks";
// import Pricing from "./Pricing";
// import { DiscordIcon } from "../../Icon/Discord";
// import ButtonText from "../../Button/Text";
// import { useStore } from "../../../service/mobx";

export default function Capabilities() {
  const [clicked, setClicked] = useState(false);
  const [tab, setTab] = useState(0);
  const options = [
    [
      "Distills papers for you",
      "paper.png",
      "Learn quickly with 1-click summaries, key takeaways, and comparisons across research papers"
    ],
    [
      "Reports what's trending and relevant",
      "feed.png",
      "See daily updates from the Community and tasks you love"
    ],
    [
      "Answers accurately and cites sources",
      "distill.png",
      "Find what you're looking for with an agent that's read every AI paper"
    ]
  ];

  useEffect(() => {
    if (clicked === false) {
      const id = setInterval(
        () => setTab(tab => (tab + 1 === 3 ? 0 : tab + 1)),
        7e3
      );

      return () => clearInterval(id);
    }
  }, [clicked]);

  return (
    <Section
      height="100vh"
      pt={4}
      bgcolor="dark.surface.container.lowest"
      overflow="hidden"
    >
      <Container maxWidth="extraLarge">
        <Typography
          color="dark.surface.on.color"
          textAlign={{ compact: "center", expanded: "unset" }}
          typography={{ compact: "headlineLg", expanded: "displayLg" }}
        >
          Explore capabilities
        </Typography>
      </Container>
      <Grid
        container
        spacing={4}
        columns={10}
        height="100%"
        alignItems="center"
        justifyContent="space-around"
      >
        <Grid item compact={10} expanded={4}>
          <Stack
            spacing={1}
            height="100%"
            textAlign={{ compact: "center", expanded: "center" }}
          >
            {options.map(([title], index) => (
              <Tab
                key={title}
                title={title}
                selected={index === tab}
                onClick={() => {
                  setTab(index);
                  setClicked(true);
                }}
                sx={{
                  typography: { compact: "bodyLg", expanded: "headlineSm" }
                }}
              />
            ))}
          </Stack>
        </Grid>
        <Grid item compact={10} expanded={6}>
          <Typography
            paragraph
            mb={3}
            variant="headlineSm"
            color="dark.secondary.color"
          >
            {options[tab][2]}
          </Typography>
          <Box
            borderRadius={theme => ({
              compact: theme.shape.xl.round,
              expanded: theme.shape.xl.top
            })}
            component="img"
            maxWidth="100%"
            src={`/landing/${options[tab][1]}`}
          />
        </Grid>
      </Grid>
    </Section>
  );
}
